import { render, staticRenderFns } from "./CopiarRota.vue?vue&type=template&id=3c1ae239&"
import script from "./CopiarRota.vue?vue&type=script&lang=js&"
export * from "./CopiarRota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports